import { Directive, Inject, PLATFORM_ID, TemplateRef, ViewContainerRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[browserOnly]',
  standalone: true,
})
export class BrowserOnlyDirective {
  constructor(
    template: TemplateRef<unknown>,
    viewContainer: ViewContainerRef,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    if (isPlatformBrowser(platformId)) {
      viewContainer.createEmbeddedView(template);
    }
  }
}
